// Winner close-up portraits live in a separate Pinata IPFS folder, named by the
// Booga's DISPLAY number (e.g. 130.png, 237.png — no zero-padding). That display
// number is the "#130" in the metadata name and matches the wallet/IPFS numbering.
// IMPORTANT: it is NOT the on-chain nonce — for this collection the hex nonce in the
// identifier (BOOGAS-afc98d-XXXX) differs from the display number, so we read the
// name first and only fall back to the nonce when a name isn't available. Override
// the gateway base with VITE_PFP_BASE if the collection ever moves.
const PFP_BASE: string =
  import.meta.env.VITE_PFP_BASE ??
  "https://boogas.mypinata.cloud/ipfs/bafybeieh6h7tygmznd673z5ziab4cjph7vb4wuaa2546jzxug63p2nsqli";

/** A Booga's display number — the "#130" in its name (canonical for IPFS/wallet),
 * with the identifier hex nonce only as a last-ditch fallback. */
export function boogaNumber(identifier: string, name?: string): number | undefined {
  const m = name?.match(/#\s*(\d+)/);
  if (m) {
    const n = parseInt(m[1]!, 10);
    if (Number.isFinite(n) && n > 0) return n;
  }
  const hex = identifier.split("-").pop();
  if (hex && /^[0-9a-fA-F]+$/.test(hex)) {
    const n = parseInt(hex, 16);
    if (Number.isFinite(n) && n > 0) return n;
  }
  return undefined;
}

/** Close-up PFP URL for a fighter, or undefined if no number can be derived. */
export function pfpUrl(identifier: string, name?: string): string | undefined {
  const n = boogaNumber(identifier, name);
  return n === undefined ? undefined : `${PFP_BASE}/${n}.png`;
}
